module.exports = __webpack_public_path__ + "static/media/solidaire.4671b72f.jpg";